import React, { useState, useImperativeHandle, useCallback } from 'react';
import StreamPropertyPopup from './components/StreamPropertyPopup';

const InfoPopup = React.forwardRef((props, ref) => {
    const [popups, setPopups] = useState([]);

    const  addInfoStreamPropertyPopup = useCallback((getMADropdownData, graph, linkId, pageX, pageY) => {
        if (!linkId?.cid) return;
        setPopups(prevPopups => {
          const popupExists = prevPopups.some(popup => popup.id === linkId.cid);
          if (!popupExists) {
            return [...prevPopups, { 
              getMADropdownData, 
              id: linkId.cid, 
              isOpen: true, 
              graph, 
              linkId, 
              pageX, 
              pageY 
            }];
          }
          return prevPopups;
        });
      }, []);

    const openInfoStreamPropertyPopup = useCallback((id) => {
        setPopups(prevPopups => prevPopups.map(popup =>
          popup.id === id ? { ...popup, isOpen: true } : popup
        ));
    }, []);

    const hideInfoStreamPropertyPopup = useCallback((id) => {
        setPopups(prevPopups => prevPopups.map(popup =>
          popup.id === id ? { ...popup, isOpen: false } : popup
        ));
    }, []);

    const closeInfoStreamPropertyPopup = useCallback((id) => {
        setPopups(prevPopups => prevPopups.filter(popup => popup.id !== id));
    }, []);

    useImperativeHandle(ref, () => ({
        addInfoStreamPropertyPopup,
        openInfoStreamPropertyPopup,
        hideInfoStreamPropertyPopup,
        closeInfoStreamPropertyPopup,
        popups
    }), [addInfoStreamPropertyPopup, openInfoStreamPropertyPopup, hideInfoStreamPropertyPopup, closeInfoStreamPropertyPopup, popups]);

    return (
        <>
          {popups.map(popup => (
            <StreamPropertyPopup
              key={`${popup.id}-${props.simulationVersion || 0}`}
              isOpen={popup.isOpen}
              onOpen={() => openInfoStreamPropertyPopup(popup.id)}
              onClose={() => closeInfoStreamPropertyPopup(popup.id)}
              graph={popup.graph}
              linkId={popup.linkId}
              simulateFunction={props.simulateFunction}
              selectedMassConversion={props.selectedMassConversion}
              setSelectedMassConversion={props.setSelectedMassConversion}
              massConversionOptions={props.massConversionOptions}
              selectedFractionConversion={props.selectedFractionConversion}
              setSelectedFractionConversion={props.setSelectedFractionConversion}
              fractionConversionOptions={props.fractionConversionOptions}
              econVars={props.econVars}
              pageX={popup.pageX}
              pageY={popup.pageY}
              getMADropdownData={popup.getMADropdownData}
            />
          ))}
        </>
      );
    });

export default InfoPopup;
